import httpService from '@/utils/http-service'

const module = 'staff'
const controller = 'staff'

export function indexStaff() {
	return httpService.request({
		url: `${module}/${controller}/index`
	})
}

export function searchStaff(params) {
	return httpService.request({
		url: `${module}/${controller}/search`,
		params: params
	})
}

export function readStaff(id) {
	return httpService.request({
		url: `${module}/${controller}/read`,
		params: {id}
	})
}

export function createStaff() {
	return httpService.request({
		url: `${module}/${controller}/create`
	})
}

export function saveStaff(data) {
	return httpService.request({
		method: 'POST',
		url: `${module}/${controller}/save`,
		data: data
	})
}

export function editStaff(id) {
	return httpService.request({
		url: `${module}/${controller}/edit`,
		params: {id}
	})
}

export function updateStaff(data) {
	return httpService.request({
		method: 'POST',
		url: `${module}/${controller}/update`,
		data: data
	})
}

export function resetPassword(id) {
	return httpService.request({
		method: 'POST',
		url: `${module}/${controller}/resetpassword`,
		data: {id}
	})
}

export function updatePassword(data) {
	return httpService.request({
		method: 'POST',
		url: `${module}/${controller}/updatepassword`,
		data: data
	})
}

export function readme() {
	return httpService.request({
		url: `${module}/${controller}/readme`
	})
}

export function selectStaff(params) {
	return httpService.request({
		url: `${module}/${controller}/select`,
		params: params
	})
}